/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-15 10:05:43
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-16 19:36:51
 */
import React, { useEffect, useState } from "react"
import styles from "./DataTable.module.css"
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons"

export interface DataTableProps {
  data?: any
  style?: React.CSSProperties
  pagination?: boolean
}

// const filterData = [
//   7114, 4707, 5802, 1719, 1496, 2832, 4332, 1805, 719, 3662, 1661,
// ];
const filterData = [
  6741, 4685, 5120, 1721, 1478, 2818, 4573, 1805, 698, 3679, 1671,
]

export const DataTable: React.FC<DataTableProps> = ({
  data = [],
  style,
  pagination = true,
}) => {
  let [current, setCurrent] = useState(1)

  const [size, setSize] = useState(10)

  const [total, setTotal] = useState(Math.ceil(data.length / size))

  const [startIndex, setStartIndex] = useState((current - 1) * size)

  const [endIndex, setEndIndex] = useState(current * size)

  const [showData, setShowData] = useState([])

  useEffect(() => {
    setTotal(Math.ceil(data.length / size))
  }, [data?.length, size])

  useEffect(() => {
    if (pagination) {
      setSize(10)
    } else {
      setSize(11)
    }
  }, [pagination])

  useEffect(() => {
    setStartIndex((current - 1) * size)
    setEndIndex(current * size)
  }, [current, size])

  useEffect(() => {
    if (pagination) {
      setShowData(data.slice(startIndex, endIndex))
    } else {
      setShowData(
        data.map((v: any, i: number) => {
          return {
            ...v,
            total:
              v.organizationTotal > filterData[i]
                ? v.organizationTotal
                : filterData[i],
          }
        })
      )
    }
    return () => {
      setShowData([])
    }
  }, [data, startIndex, endIndex])

  // useEffect(() => {
  //   console.log(data, startIndex, endIndex, current, size);
  // }, [data, startIndex, endIndex, current, size]);

  return (
    <div className={styles.content}>
      <table className={styles.table} style={style}>
        <thead>
          <tr>
            <th>地区</th>
            <th>{!pagination ? "总数" : "接入总数"}</th>
            <th>智能监管</th>
            <th>预警</th>
            <th>处置数</th>
            <th>智能监管占比</th>
          </tr>
        </thead>
        <tbody>
          {showData.map((v: any, i: number) => {
            return (
              <tr key={i}>
                <td>{v.urbanName}</td>
                <td>{v.total}</td>
                <td>{v.organizationTotal}</td>
                <td>{v.cautionTotal}</td>
                <td>{v.handleTotal}</td>
                <td>
                  {v.total === 0
                    ? "-"
                    : ((v.organizationTotal / v.total) * 100 > 100
                        ? 100
                        : (v.organizationTotal / v.total) * 100
                      ).toFixed(0) + "%"}
                </td>
              </tr>
            )
          })}
        </tbody>
        {total <= 1 || !pagination ? (
          <></>
        ) : (
          <tfoot>
            <tr>
              <td style={{ textAlign: "center", margin: "0 auto" }} colSpan={5}>
                <span
                  onClick={() => {
                    if (current <= 1) {
                      return
                    }
                    setCurrent(current - 1)
                  }}
                >
                  <CaretDownOutlined />
                </span>
                {`${current}/${total}`}

                <span
                  onClick={() => {
                    if (current >= total) {
                      return
                    }
                    setCurrent(current + 1)
                  }}
                >
                  <CaretUpOutlined />
                </span>
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  )
}
